/**
 * Wishlist basis: localStorage + data-wishlist-hook
 */
(function () {
  'use strict';

  var KEY = 'nw_wishlist_v1';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function write(ids) {
    try {
      localStorage.setItem(KEY, JSON.stringify(ids));
    } catch (e) {
      /* ignore */
    }
  }

  function toggle(id) {
    var ids = read();
    var i = ids.indexOf(id);
    if (i >= 0) ids.splice(i, 1);
    else ids.push(id);
    write(ids);
    return ids.indexOf(id) >= 0;
  }

  function isWishlisted(id) {
    return read().indexOf(id) >= 0;
  }

  function init() {
    document.querySelectorAll('[data-nw-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (!id) return;
      btn.setAttribute('aria-pressed', isWishlisted(id) ? 'true' : 'false');

      btn.addEventListener('click', function () {
        var on = toggle(id);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.dispatchEvent(
          new CustomEvent('nw:wishlist-change', { detail: { productId: id, active: on } })
        );
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
